export default __webpack_public_path__ + "static/media/ct213.c048aac4.png";